(function (skyward, $, undefined)
{
    "use strict";
    skyward.tilevieweel = skyward.tilevieweel || {};

    var init = function (selector)
    {
        $(selector).find(".tileViewEEL").not(".eventsBound").each(function ()
        {
            skyward.tilevieweel.registerTileViewEEL(this);
        });
    };

    skyward.tilevieweel.registerTileViewEEL = function (origTileViewEEL, customInputOptions, customEelOptions)
    {
        var tileViewEEL = $(origTileViewEEL);
        var tileViewEELValue = tileViewEEL.find(".tileViewEEL_value");
        var searchBox = tileViewEEL.find(".tileViewEEL_search");
        var searchButton = tileViewEEL.find(".tileViewEEL_searchButton");
        var searchData = searchBox.data();
        var eel;
        var popupID = searchBox.attr("id") + "_popup";

        var userInput =
        {
            input: searchBox,
            button: searchButton,
            customKeyDownHandler: keyDownHandler
        };
        userInput = $.extend(userInput, customInputOptions);

        if (!skyward.global.mobileAccess)
        {
            skyward.eel.setFocusToTextBoxOnClick(tileViewEEL);
        }

        const label = tileViewEEL.findLabel();
        if (label.length)
        {
            label.attr("for", searchBox.addIds().attr("id"));
        }

        var eelOptions =
        {
            key: tileViewEEL,
            valueInput: tileViewEELValue,
            userInputs: [userInput],
            getSelectionListContainer: function ()
            {                
                var popupContent = $("<div />", { id: popupID, 'class': "tileViewEELModalContainer anchored popup noAnchoredTail" });
                popupContent.on("click", ".templatedResult:not(.ignoreClickEvent)", function ()
                {
                    var tile = $(this);

                    var selectedRow = $("#" + popupID).find(".templatedResult.selected");
                    selectedRow.removeClass("selected");
                    tile.addClass("selected");

                    eel.selectCurrentHighlightedValue();
                });
                    
                return popupContent;
            },
            getSelectionList: function (includeSubsequentRecords)
            {
                var deferred = $.Deferred();

                $.ajax(
                {
                    url: skyward.global.virtualDir + "Common/TileViewEEL/ViewSearchResults/",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                        data: skyward.tilevieweel.getPostData(searchData, searchBox, tileViewEELValue.val(), includeSubsequentRecords),
                    success: function (data)
                    {
                        var popupContent = $("<div>", { 'class': 'columnLayoutWrapper--tileViewEEL'});
                        var result;

                        if (data.toolbarHtml)
                        {
                            var toolbar = $("<div>", { 'class': "toolbar--browseControls tileviewEEL" }).append(data.toolbarHtml);
                            popupContent.append(toolbar);
                        }

                        if (data.templatedItems.length > 0)
                        {
                            //Add the templated results to the div
                            var selectedResult = null;
                            var foundServerSelectedKey = false;
                            // jquery.data() would automatically deserialize json data
                            var localSelectedKey = tileViewEEL.attr("data-selected-item-key");
                            for (var i = 0; i < data.templatedItems.length; i++)
                            {
                                var templatedResult = $(data.templatedItems[i]);
                                var resultKey = templatedResult.attr("data-id");

                                if (!foundServerSelectedKey)
                                {
                                    if (resultKey === data.selectedItemId)
                                    {
                                        selectedResult = templatedResult;
                                        foundServerSelectedKey = true;
                                    }
                                    else if (selectedResult === null || resultKey === localSelectedKey)
                                    {
                                        selectedResult = templatedResult;
                                    }
                                }

                                popupContent.append(templatedResult);
                            }

                            if (selectedResult)
                            {
                                selectedResult.addClass("selected");
                                searchBox.attr("aria-activedescendant", selectedResult.addIds().attr("id"));

                            }
                        }
                        else
                        {
                            var noRecords = $("<p>", { text: "No records to display" });
                            result = $("<div>", { class: "noRecordsInBrowse browseRow templatedResult ignoreClickEvent selectorElementsCenter" }).append(noRecords);
                            popupContent.append(result);
                        }

                        deferred.resolve(popupContent);
                    },
                    error: function ()
                    {
                        deferred.reject();
                    }
                });

                return deferred.promise();
            },
            selectionListPositioningOptions: 
            {
                getRows: function () { return $("#" + popupID).find('.templatedResult, .toolbar--browseControls.tileviewEEL'); },
                getHeaderRow: function () { return $("#" + popupID).find('.templatedResult').first(); }
            },
            setCurrentEnteredValue: function (input)
            {
                $.ajax(
                {
                    url: skyward.global.virtualDir + "Common/TileViewEEL/ValidateText/",
                    type: "POST",
                    dataType: "JSON",
                    data: skyward.tilevieweel.getPostData(searchData, searchBox),
                    success: function (data)
                    {
                        if (!data.isValid)
                        {
                            updateBoxes(null);
                            return;
                        }

                        skyward.tilevieweel.populateBoxes(tileViewEEL, data, data.id);
                        tileViewEEL.trigger('eelComplete');
                    }
                });
            },
            setCurrentHighlightedValue: function ()
            {
                var selectedRow = $("#" + popupID).find(".templatedResult.selected");
                updateBoxes(selectedRow.attr("data-id"));
            },
            clearValues: function ()
            {
                if (!searchBox.val())
                {
                    updateBoxes(null);
                }
                else
                {
                    updateBoxes(tileViewEELValue.val());
                }
            }
        };
        eelOptions = $.extend(eelOptions, customEelOptions);

        eelOptions.onSelectionListLoad = function ()
        {
            var popupContent = $("#" + popupID);
            var selectedRow = popupContent.find(".templatedResult.selected");

            var additionalTileViewEELPadding = 2;
            popupContent.outerHeight(popupContent.outerHeight() + additionalTileViewEELPadding);

            scrollIntoView(selectedRow);

            if (customEelOptions && customEelOptions.onSelectionListLoad)
            {
                customEelOptions.onSelectionListLoad();
            }
        };

        eelOptions.beforeOpen = function ()
        {
            searchBox.attr("aria-expanded", "true");
            customEelOptions?.beforeOpen ? customEelOptions.beforeOpen() : null;
        };

        eelOptions.beforeClose = function ()
        {
            searchBox.attr("aria-expanded", "false");
            customEelOptions?.beforeClose ? customEelOptions.beforeClose() : null;
        };

        function keyDownHandler(event)
        {
            var selectedRow = $("#" + popupID).find(".templatedResult.selected");
            if (selectedRow.length === 0)
            {
                return;
            }

            var eventKeys = skyward.keys.getKeyNamesFromEvent(event);

            var goUp = eventKeys.ARROW_LEFT || eventKeys.ARROW_UP;
            var goDown = eventKeys.ARROW_RIGHT || eventKeys.ARROW_DOWN;

            if (!goUp && !goDown)
            {
                return;
            }

            var nextRow;
            if (goUp)
            {
                nextRow = selectedRow.prevAll().not(".js-nonSelectableOption").first();
            }
            else
            {
                nextRow = selectedRow.nextAll().not(".js-nonSelectableOption").first();
            }

            updateSelectedRow(selectedRow, nextRow);

            event.preventDefault();
        }

        var updateSelectedRow = function (selectedRow, nextRow)
        {
            var popupContent = $("#" + popupID);

            if (!nextRow || nextRow.length === 0 || popupContent.length === 0)
            {
                return;
            }

            selectedRow.removeClass("selected");
            nextRow.addClass("selected");
            searchBox.attr("aria-activedescendant", nextRow.addIds().attr("id"));

            scrollIntoView(nextRow);
        };

        var scrollIntoView = function (row)
        {
            row.scrollintoview(
            {
                duration: 0,
                direction: "vertical",
                viewPadding: { y: 0 }
            });
        };
            
        var updateBoxes = function (selectedID)
        {
            if (!selectedID)
            {
                searchBox.val("");
                searchBox.change();
                tileViewEELValue.val("");
                tileViewEELValue.change();
                return false;
            }

            return $.ajax(
            {
                url: skyward.global.virtualDir + "Common/TileViewEEL/ValidateSelection/",
                type: "POST",
                dataType: "JSON",
                data: skyward.tilevieweel.getPostData(searchData, searchBox, selectedID),
                success: function (data)
                {
                    skyward.tilevieweel.populateBoxes(tileViewEEL, data, selectedID);
                    tileViewEEL.trigger('eelComplete');
                }
            });
        };

        eel = skyward.eel.createEel(eelOptions);
        tileViewEEL.addClass("eventsBound");

        var obj =
        {
            tileViewEEL: tileViewEEL,
            hiddenValue: tileViewEELValue,
            searchBox: searchBox,
            searchButton: searchButton,
            eel: eel
        };

        return obj;
    };

    skyward.tilevieweel.getParts = function (tileViewEel)
    {
        var parts = {};
        parts.value = tileViewEel.find('.tileViewEEL_value');
        parts.searchBox = tileViewEel.find('.tileViewEEL_search');
        return parts;
    };

    skyward.tilevieweel.populateBoxes = function (tileViewEEL, ajaxData, id)
    {
        var searchBox = tileViewEEL.find(".tileViewEEL_search");
        searchBox.val(ajaxData.search || "");
        searchBox.data().currentValue = ajaxData.search || "";

        var tileViewEELValue = tileViewEEL.find(".tileViewEEL_value");
        tileViewEELValue.val(id);
        tileViewEELValue.change();
    };

    skyward.tilevieweel.getPostData = function (searchData, searchBox, selectedID, includeSubsequentRecords)
    {
        var postData =
        {
            securityHash: searchData.securityHash,
            area: searchData.area,
            controller: searchData.controller,
            templateName: searchData.templateName,
            filter: JSON.stringify(searchData.filter),
            postData: JSON.stringify(searchData.postdata),
            pageStateControlValues: searchBox.attr("name"),
            searchText: skyward.extensions.encodeHtml(searchBox.val()),
            dependency: JSON.stringify(getDependencyData(searchBox)),
            id: selectedID,
            includeSubsequentRecords: includeSubsequentRecords
        };

        if (searchData.queryParameterData !== null)
        {
            postData.queryParameterData = JSON.stringify(searchData.queryParameterData);
        }

        return postData;

        function getDependencyData(searchBox)
        {
            if (!searchBox.data("dynamicfiltervalue"))
            {
                return null;
            }

            var filterPostData = {};

            var dependentFields = searchBox.data("dynamicfilterfield").split(',');
            var dependentValues = searchBox.data("dynamicfiltervalue").split(',');

            for (var i = 0; i < dependentFields.length; i++)
            {
                filterPostData[dependentFields[i]] = skyward.controls.getValue($('[name="' + dependentValues[i] + '"]'));
            }

            return filterPostData;
        }
    };
        
    skyward.window.registerLoadDOMCallback(init);

}(window.skyward = window.skyward || {}, window.jQuery));